import { useMutation } from '#query';
import { unsubscribeRingcentralEmail } from '../../services';

type UnsubscribeRingcentralEmailMutationVariables = {
  token: string;
};

export const useUnsubscribeRingcentralEmailMutation = () =>
  useMutation<unknown, UnsubscribeRingcentralEmailMutationVariables>({
    async mutationFn({ token }) {
      await unsubscribeRingcentralEmail({ body: { token } });
    },
  });
